import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';

import { UserService } from '@intranet/modules/users/user.service';

import { ConfirmDialogData } from '@intranet/components/dialog/confirm-dialog/confirm-dialog.component';
import { switchMap } from 'rxjs';
import {
    User,
    UserGroup,
    UserRoleMember,
} from '@intranet/modules/users/user.types';
import { HotkeyService } from 'src/app/core/services/hotkey.service';

@Component({
    selector: 'admin-group',
    templateUrl: './admin-group-manage.component.html',
    styleUrls: ['./admin-group-manage.component.scss'],
})
export class AdminGroupManageComponent implements OnInit {
    @Input() userGroup: UserGroup | null;
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() update: EventEmitter<UserGroup> = new EventEmitter<UserGroup>();
    @ViewChild('form') groupForm: NgForm;


    title: string;
    isLoading: boolean = false;
    error: string | null;
    isCreate: boolean = false;
    confirmDialog: ConfirmDialogData = new ConfirmDialogData();

    constructor(
        private userService: UserService,
        private router: Router,
        private route: ActivatedRoute,
        private hotkeyService: HotkeyService
    ) {}

    ngOnInit(): void {
        // Register hotkey for "Cancel" action (Ctrl + Q)
        this.hotkeyService.registerHotkey('ctrl+q', 'Cancel action', () => this.onCancel());

        // Register hotkey for "Save" action (Ctrl + Alt + S)
        this.hotkeyService.registerHotkey('ctrl+alt+s', 'Save changes', () => {
          if (this.groupForm?.valid && !this.groupForm?.pristine) {
              this.onSubmit();
          }
      });

        this.route.paramMap
            .pipe(
                switchMap((p) => {
                    const userGroupId = this.userGroup?.userGroupId;
                    if (!userGroupId) {
                        this.title = 'Add team';
                        return this.userService.initNewUserGroup();
                    }

                    this.title = 'Edit team';
                    return this.userService.getUserGroupDetails(userGroupId);
                })
            )
            .subscribe({
                next: response => {
                    this.userGroup = response.userGroup;
                    this.isCreate = response.isCreate;
                },
                error: (error) => {
                    this.error = error;
                },
            });
    }

    onSubmit() {
        if (!this.userGroup) {
            return;
        }

        const result$ = this.isCreate
            ? this.userService.addNewUserGroup(
                  this.userGroup
              )
            : this.userService.updateUserGroup(this.userGroup);

        result$.subscribe({
                next: (res) => {
                    if (!res.success) {
                        this.error = res.error;
                    } else {
                        this.update.emit(this.userGroup);
                        this.closeDialog();
                    }
                },
                error: (error) => {
                    this.error = error;
                }
            }
        );
    }


    onCancel() {
        this.closeDialog();
    }

    closeDialog() {
        this.close.emit(false);
    }
}
